import { combineStateReducer } from "../utils/combineStateReducer";
import { State, Selector } from "./types";

import * as retrieveCapacity from "./retrieveCapacity";
import * as retrieveWorkload from "./retrieveWorkload";
import * as retrieveWorkloadProjects from "./retrieveWorkloadProjects";
import * as retrieveOccupancy from "./retrieveOccupancy";
import * as adjustWorkload from "./adjustWorkload";
import * as adjustCapacity from "./adjustCapacity";

const initialState: State = {
  retrieveCapacity: retrieveCapacity.initialState,
  retrieveWorkload: retrieveWorkload.initialState,
  retrieveWorkloadProjects: retrieveWorkloadProjects.initialState,
  retrieveOccupancy: retrieveOccupancy.initialState,
  adjustWorkload: adjustWorkload.initialState,
  adjustCapacity: adjustCapacity.initialState,
};

const reduceState = combineStateReducer(initialState, {
  retrieveCapacity: retrieveCapacity.reduceState,
  retrieveWorkload: retrieveWorkload.reduceState,
  retrieveWorkloadProjects: retrieveWorkloadProjects.reduceState,
  retrieveOccupancy: retrieveOccupancy.reduceState,
  adjustWorkload: adjustWorkload.reduceState,
  adjustCapacity: adjustCapacity.reduceState,
});

function createSelector(getState: () => State): Selector {
  return {
    ...retrieveCapacity.createSelector(() => getState().retrieveCapacity),
    ...retrieveWorkload.createSelector(() => getState().retrieveWorkload),
    ...retrieveWorkloadProjects.createSelector(
      () => getState().retrieveWorkloadProjects,
    ),
    ...retrieveOccupancy.createSelector(() => getState().retrieveOccupancy),
    ...adjustWorkload.createSelector(() => getState().adjustWorkload),
    ...adjustCapacity.createSelector(() => getState().adjustCapacity),
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
